<div class="header-container">
  <div class="logo-container">
    <button mat-icon-button class="sidebar-toggle" (click)="toggleSidebar()">
      <mat-icon>menu</mat-icon>
    </button>
    <img class="cur-pointer" (click)="goToDashboard()"
      src="assets/images/easyVTA_logo_for_whiteBG_n.png"
      alt="easyVTA" height="1%" width="75%">
  </div>
</div>

<div class="header-container">
  <div class="user-action">
    <div class="user-avatar" [matMenuTriggerFor]="userMenu">
      <span class="initials">{{ userInitials }}</span>
    </div>
    @if (!userPictureOnly) {
      <span class="user-name" [matMenuTriggerFor]="userMenu">{{ user?.name }}</span>
    }
    <mat-menu #userMenu="matMenu" xPosition="before">
      <button mat-menu-item (click)="navigateToProfile()">Profile</button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logOut()">Log out</button>
    </mat-menu>
  </div>
</div>
